import { Circle, HStack } from "@chakra-ui/react";
import React from "react";

const ExamEllipses = ({
  examCorrection,
  answeredQ,
  questionsCount,
  setSelectedQuestionIdx,
  selectedQuestionIdx,
  questions,
  showResult = false,
}) => {
  const path = window.location.pathname;
  const isResult =
    showResult || path.includes("exam-result") || path.includes("study");

  const questionAt = (index) => {
    if (questions?.[index]) return questions[index];
    if (path.includes("study")) return examCorrection?.[index];
    return examCorrection?.questions?.[index];
  };

  const isPendingEssay = (question) => {
    if (!path.includes("exam-result") || !question) return false;
    if (
      !Object.prototype.hasOwnProperty.call(question, "student_answer_id") ||
      !Object.prototype.hasOwnProperty.call(question, "teacher_grade")
    ) {
      return false;
    }
    return question.student_answer_id == null && question.teacher_grade == null;
  };

  const resultColor = (index) => {
    const question = questionAt(index);
    if (isPendingEssay(question)) return "yellow.400";
    const wrong = question?.wrong;
    if (wrong == 1) return "red.500";
    if (wrong == 0) return "green.400";
    return "main_1";
  };

  return (
    <HStack flexWrap="wrap">
      {[...Array(questionsCount)]?.map((data, index) => {
        const circleColor = isResult ? resultColor(index) : null;
        return (
          <Circle
            key={index}
            size="40px"
            cursor="pointer"
            bg={
              isResult
                ? circleColor
                : selectedQuestionIdx == index
                ? "white"
                : answeredQ?.includes(index.toString())
                ? "gray.400"
                : "red.500"
            }
            color={
              isResult
                ? "white"
                : selectedQuestionIdx == index
                ? "main_1"
                : "white"
            }
            border="1px solid"
            borderColor={
              selectedQuestionIdx == index
                ? "main_1"
                : isResult
                ? circleColor
                : answeredQ?.includes(index.toString())
                ? "green.400"
                : "red.300"
            }
            onClick={() => setSelectedQuestionIdx(index)}
          >
            {index + 1}
          </Circle>
        );
      })}
    </HStack>
  );
};

export default ExamEllipses;
